import { TimeZoneDateFnsService } from 'app/core/services/time-zone-date-fns.service';
import { JournalFileTypeHelper } from 'app/shared/enum-helpers/journal-file-type.enum.helper';
import { JournalTypeHelper } from 'app/shared/enum-helpers/journal-type.enum.helper';
import { JournalFileType } from 'app/shared/enums/journal-file-type.enum';
import { NotificationStatus } from 'app/shared/enums/notification-status.enum';
import { CustomDatePipe } from 'app/shared/pipes/custom-date.pipe';
import { ReadJournalNotificationViewModel } from 'app/shared/prothesis-api-view-models/read-journal-notification-view-model';
import { buildNotificationCardTitle } from '../../build-notification-card-title';
import { JournalNotificationCardModel } from './journal-notification-card.model';

export class JournalNotificationModelHelper {
  public static build(): JournalNotificationCardModel {
    const journalNotificationCard = new JournalNotificationCardModel();
    return journalNotificationCard;
  }

  public static fromViewModel(
    readJournalNotificationViewModels: ReadJournalNotificationViewModel[],
    customDatePipe: CustomDatePipe,
  ): Array<JournalNotificationCardModel> {
    const journalNotifications = new Array<JournalNotificationCardModel>();
    readJournalNotificationViewModels.forEach((readJournalNotificationViewModel) => {
      const journalNotification = this._createModel(readJournalNotificationViewModel, customDatePipe);
      journalNotifications.push(journalNotification);
    });

    return journalNotifications;
  }

  public static fromViewModelSingle(
    readJournalNotificationViewModel: ReadJournalNotificationViewModel,
    customDatePipe: CustomDatePipe,
  ): JournalNotificationCardModel {
    return this._createModel(readJournalNotificationViewModel, customDatePipe);
  }

  private static _createModel(
    readJournalNotificationViewModel: ReadJournalNotificationViewModel,
    customDatePipe: CustomDatePipe,
  ): JournalNotificationCardModel {
    const journalNotificationCard = new JournalNotificationCardModel();
    if (readJournalNotificationViewModel.journalNotificationDetail.journalFileType === JournalFileType.Pdf) {
      journalNotificationCard.colorClass = 'notification-accent';
    } else if (readJournalNotificationViewModel.journalNotificationDetail.journalFileType === JournalFileType.Xlsx) {
      journalNotificationCard.colorClass = 'notification-green';
    } else {
      journalNotificationCard.colorClass = 'notification-green';
    }
    journalNotificationCard.discriminator = readJournalNotificationViewModel.discriminator;
    journalNotificationCard.notificationDate = TimeZoneDateFnsService.toLaboratoryTimeZone(
      readJournalNotificationViewModel.notificationDate,
    );
    journalNotificationCard.readDate = TimeZoneDateFnsService.toLaboratoryTimeZone(readJournalNotificationViewModel.readDate);
    journalNotificationCard.title = buildNotificationCardTitle(
      'Journal',
      readJournalNotificationViewModel.notificationDate,
      customDatePipe,
    );

    journalNotificationCard.messageLine1 = JournalNotificationModelHelper.buildMessageLine1(readJournalNotificationViewModel);
    journalNotificationCard.journalFileType = readJournalNotificationViewModel.journalNotificationDetail.journalFileType;

    journalNotificationCard.statusFailedFlag = readJournalNotificationViewModel.status === NotificationStatus.Failed;
    journalNotificationCard.statusNothingToDoFlag = readJournalNotificationViewModel.status === NotificationStatus.NothingToDo;
    journalNotificationCard.statusPendingFlag = readJournalNotificationViewModel.status === NotificationStatus.Pending;
    journalNotificationCard.statusSucceedFlag = readJournalNotificationViewModel.status === NotificationStatus.Succeed;

    journalNotificationCard.uuid = readJournalNotificationViewModel.uuid;
    return journalNotificationCard;
  }

  private static buildMessageLine1(readJournalNotificationViewModel: ReadJournalNotificationViewModel): string {
    switch (readJournalNotificationViewModel.journalNotificationDetail.journalFileType) {
      case JournalFileType.Fec:
      case JournalFileType.Xlsx:
      case JournalFileType.Pdf:
        return (
          JournalFileTypeHelper.translateEnum(readJournalNotificationViewModel.journalNotificationDetail.journalFileType) +
          ' - ' +
          JournalTypeHelper.translateEnum(readJournalNotificationViewModel.journalNotificationDetail.journalType)
        );
      default:
        return '';
    }
  }
}
